import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-wizard-topbar',
  templateUrl: './wizard-topbar.component.html',
  styleUrls: ['./wizard-topbar.component.scss'],
})
export class WizardTopbarComponent {
  @Output() closeWizard = new EventEmitter<void>();

  onCloseClick(): void {
    this.closeWizard.emit();
  }
}

